import React, { useCallback, useEffect, useRef, useState } from "react";
import cx from "classnames";
import propTypes from "prop-types";
import { debounce, get, map, noop, size } from "lodash";

import SongListItem from "./songListItem/songListItem";

import LoadingSkeleton from "../loadingSkeleton/LoadingSkeleton";
import musicPlayerStore from "../../zustand/musicPlayer.store";

import SearchInput from "./SearchInput/SearchInput";

import styles from "./searchBar.module.scss";
import { fetchSongs } from "../../actions/songs.actions";
import userStore from "../../zustand/user.store";
import { showToaster } from "../../helpers/toaster.helpers";
import { downloadSongImage } from "../../helpers/generel.helpers";
import imageStore from "../../zustand/image.store";

const SearchBar = (props) => {
  const {
    containerClassName,
    songsListContainerClassName,
    songNameClassName,
    songArtistClassName,
    contentContianerClassName,
    hasBtn,
    onBtnClick,
  } = props;

  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const { playSearchSong } = musicPlayerStore(
    (state) => ({
      playSearchSong: state.playSearchSong,
    }),
    (action) => action
  );

  const { addImage } = imageStore((state) => ({
    addImage: state.addImage,
  }));

  const [isActive, setIsActive] = useState(false);
  const [songs, setSongs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const toCallOneTime = useRef(false);

  const handleInputFocus = () => {
    if (userOffline)
      return showToaster(
        "error",
        "You are offline, please check your internet connection"
      );
    setIsActive(true);
  };

  const handlebackDropClick = () => {
    setIsActive(false);
  };

  const handleSongItemClick = (song) => () => {
    playSearchSong(song);
    handlebackDropClick();
  };

  const handleSearchKeyChange = (e) => {
    if (userOffline) {
      return showToaster(
        "error",
        "You are offline, please check your internet connection"
      );
    }
    const { value } = e.target;
    functionWithDebounce(value);
  };

  const functionToRun = async (val) => {
    const songs = await fetchSongs(val, userOffline);
    setSongs(songs);
  };

  const functionWithDebounce = useCallback(
    debounce((val) => functionToRun(val), 400),
    []
  );

  const downloadSongImages = useCallback(async () => {
    for (let index = 0; index < size(songs); index++) {
      if (index >= size(songs)) return;
      const imageToDownload = get(songs, `${index}.thumbnail_img`, "");

      try {
        const result = await downloadSongImage(imageToDownload);
        if (result) {
          addImage(imageToDownload);
        }
      } catch (error) {
        //
      }
    }
  }, [songs, addImage]);

  useEffect(() => {
    downloadSongImages();
  }, [downloadSongImages]);

  useEffect(() => {
    if (toCallOneTime.current) return;
    (async () => {
      toCallOneTime.current = true;
      setIsLoading(true);
      const songs = await fetchSongs(userOffline);
      setSongs(songs);
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      <div
        className={cx(styles.container, containerClassName, {
          [styles.activeBox]: isActive,
        })}
        style={{
          pointerEvents: userOffline ? "none" : "auto",
        }}
      >
        <SearchInput
          isActive={isActive}
          onFocus={handleInputFocus}
          // searchKey={searchKey}
          onChange={handleSearchKeyChange}
        />
        {isActive && (
          <div
            className={cx(styles.itemContainer, songsListContainerClassName)}
          >
            {!isLoading ? (
              map(songs, (song, index) => {
                return (
                  <SongListItem
                    key={song.id + "searcha bar song"}
                    song={song}
                    contentContianerClassName={contentContianerClassName}
                    songNameClassName={songNameClassName}
                    songArtistClassName={songArtistClassName}
                    hasBtn={hasBtn}
                    onItemClick={handleSongItemClick(song, index)}
                    onBtnClick={onBtnClick}
                  />
                );
              })
            ) : (
              <>
                <div className={styles.skeleton}>
                  <LoadingSkeleton isSchedule />
                  <LoadingSkeleton isSchedule />
                  <LoadingSkeleton isSchedule />
                  <LoadingSkeleton isSchedule />
                  <LoadingSkeleton isSchedule />
                </div>
              </>
            )}
          </div>
        )}
      </div>
      {isActive && (
        <div onClick={handlebackDropClick} className={styles.backDrop} />
      )}
    </>
  );
};

SearchBar.propTypes = {
  containerClassName: propTypes.string,
  songsListContainerClassName: propTypes.string,
  songNameClassName: propTypes.string,
  songArtistClassName: propTypes.string,
  hasBtn: propTypes.bool,
  contentContianerClassName: propTypes.string,
  onBtnClick: propTypes.func,
  inputRef: propTypes.any,
  alreadyAddedSongIds: propTypes.array,
};

SearchBar.defaultProps = {
  containerClassName: "",
  songsListContainerClassName: "",
  songNameClassName: "",
  alreadyAddedSongIds: [],
  songArtistClassName: "",
  hasBtn: false,
  contentContianerClassName: "",
  onBtnClick: noop,
  inputRef: null,
};

export default SearchBar;
